export default "__VITE_ASSET__h_PSzH4$__"